import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { PageTitle } from "@/admin/AdminLayout";

export default function UiTextsAdmin() {
  const [langs, setLangs] = useState([]);
  const [code, setCode] = useState(null);
  const [data, setData] = useState(null);
  const [values, setValues] = useState({});
  const [filter, setFilter] = useState("");

  useEffect(() => { api.get("/admin/languages").then((r) => { setLangs(r.data); setCode((c) => c || r.data[0]?.code); }); }, []);
  useEffect(() => {
    if (!code) return;
    api.get(`/admin/ui/${code}`).then((r) => { setData(r.data); setValues({ ...r.data.defaults, ...r.data.overrides }); });
  }, [code]);

  const save = async () => {
    try { await api.put(`/admin/ui/${code}`, { strings: values }); toast.success(`Interface texts saved (${code.toUpperCase()})`); }
    catch (e) { toast.error(errorText(e)); }
  };
  if (!data) return null;
  const keys = data.keys.filter((k) => !filter || k.includes(filter.toLowerCase()) || data.reference[k].toLowerCase().includes(filter.toLowerCase()));

  return (
    <div data-testid="admin-texts-page">
      <PageTitle action={<button type="button" onClick={save} className="btn-accent px-5 py-2.5 text-xs" data-testid="texts-save">Save {code?.toUpperCase()}</button>}>Interface texts</PageTitle>
      <p className="text-sm text-[var(--muted)] mb-5">Every label on the visitor site, per language. Empty fields fall back to English. Placeholders in braces like {"{code}"} are filled in automatically.</p>
      <div className="flex flex-wrap items-center gap-2 mb-6">
        {langs.map((l) => <button key={l.code} type="button" onClick={() => setCode(l.code)} data-testid={`texts-lang-${l.code}`} className={`px-3 py-1.5 text-xs uppercase tracking-widest border ${code === l.code ? "border-[var(--accent)] text-white" : "border-[var(--line)] text-[var(--muted)]"}`}>{l.name}</button>)}
        <input className="field !w-56 !py-1.5 !text-xs ml-auto" placeholder="Filter…" value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="texts-filter" />
      </div>
      <table className="w-full admin-table text-sm" data-testid="texts-table">
        <thead><tr><th className="w-1/3">English reference</th><th>{langs.find((l) => l.code === code)?.name}</th></tr></thead>
        <tbody>
          {keys.map((k) => (
            <tr key={k}>
              <td className="text-[var(--muted)] align-top"><span className="block text-white">{data.reference[k]}</span><span className="text-[0.6rem] tracking-wider">{k}</span></td>
              <td><textarea rows={1} className="field !py-2 !text-sm min-h-[40px]" value={values[k] ?? ""} onChange={(e) => setValues({ ...values, [k]: e.target.value })} data-testid={`texts-input-${k}`} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
